import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="container" style={{ padding: 'var(--spacing-8) 0' }}>
      <div className="row justify-center">
        <div className="col col--8">
          <div className="card p-6">
            <h1 style={{ marginBottom: 'var(--spacing-6)' }}>Privacy Policy</h1>
            
            <div style={{ lineHeight: 1.6 }}>
              <p><strong>Last updated:</strong> January 2024</p>
              
              <h2>1. Information We Collect</h2>
              <p>We collect information you provide directly to us, such as when you create an account, complete your profile, or communicate with us. This may include:</p>
              <ul>
                <li>Name, email address, and phone number</li>
                <li>Profile information including age, location, and interests</li>
                <li>Personality test results and travel preferences</li>
                <li>Photos and other content you upload</li>
                <li>Communication preferences and settings</li>
              </ul>

              <h2>2. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide, maintain, and improve our services</li>
                <li>Match you with compatible travel companions</li>
                <li>Send you notifications and updates</li>
                <li>Respond to your comments and questions</li>
                <li>Ensure the safety and security of our community</li>
              </ul>

              <h2>3. Information Sharing</h2>
              <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy. We may share your information:</p>
              <ul>
                <li>With other users as part of our matching service</li>
                <li>With service providers who assist in our operations</li>
                <li>When required by law or to protect our rights</li>
                <li>With your explicit consent</li>
              </ul>

              <h2>4. Data Security</h2>
              <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>

              <h2>5. Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access and update your personal information</li>
                <li>Delete your account and associated data</li>
                <li>Opt out of certain communications</li>
                <li>Request a copy of your data</li>
              </ul>

              <h2>6. Cookies and Tracking</h2>
              <p>We use cookies and similar technologies to enhance your experience, analyze usage, and provide personalized content. You can control cookie settings through your browser preferences.</p>

              <h2>7. Third-Party Services</h2>
              <p>Our service may contain links to third-party websites or services. We are not responsible for the privacy practices of these external sites.</p>

              <h2>8. Children's Privacy</h2>
              <p>Our service is not intended for children under 18. We do not knowingly collect personal information from children under 18.</p>

              <h2>9. International Transfers</h2>
              <p>Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place for such transfers.</p>

              <h2>10. Changes to This Policy</h2>
              <p>We may update this privacy policy from time to time. We will notify you of any material changes by posting the new policy on this page.</p>

              <h2>11. Contact Us</h2>
              <p>If you have any questions about this privacy policy, please contact us at:</p>
              <p>
                <strong>Email:</strong> privacy@gradedwash.com<br/>
                <strong>Address:</strong> [Your Business Address]<br/>
                <strong>Phone:</strong> [Your Phone Number]
              </p>
            </div>

            <div style={{ marginTop: 'var(--spacing-6)', paddingTop: 'var(--spacing-4)', borderTop: '1px solid var(--gray-200)' }}>
              <Link to="/" className="btn btn--primary">Back to Home</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 